(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var key = '__HOBlackSeasonGrid2026V4';
    if (window[key]) {
      window[key].scan(document);
      return;
    }

    var selector = '[data-ho-bs-offer]';
    var panels = new Map();
    var timer = null;
    var pendingFrame = null;
    var pendingRoots = new Set();

    function release(panel) {
      panels.delete(panel);
    }

    function update(state, now) {
      var end = state.deadlines.find(function (value) { return value > now; });
      if (!end) {
        var host = state.panel.closest('.ho-bs-host');
        var label = host && host.querySelector('[data-ho-bs-label]');
        if (label) label.hidden = true;
        state.panel.hidden = true;
        if (host) host.classList.remove('ho-bs-host');
        release(state.panel);
        return;
      }

      var total = Math.ceil((end - now) / 60000);
      if (state.lastValue === total) return;
      state.lastValue = total;

      var values = [
        Math.floor(total / 1440),
        Math.floor((total % 1440) / 60),
        total % 60
      ];

      state.values.forEach(function (element, index) {
        element.textContent = String(values[index]).padStart(2, '0');
      });

      state.panel.setAttribute('aria-label',
        'Black Deal endet in ' + values[0] + (values[0] === 1 ? ' Tag, ' : ' Tagen, ') +
        values[1] + (values[1] === 1 ? ' Stunde und ' : ' Stunden und ') +
        values[2] + (values[2] === 1 ? ' Minute.' : ' Minuten.'));
    }

    function syncTimer() {
      if (panels.size && !document.hidden) {
        if (timer === null) timer = window.setInterval(tick, 1000);
      } else if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function tick() {
      var now = Date.now();
      panels.forEach(function (state, panel) {
        if (!panel.isConnected) release(panel);
        else update(state, now);
      });
      syncTimer();
    }

    function register(panel) {
      if (!panel.isConnected || panels.has(panel) || panel.hidden) return;

      var deadlines = (panel.getAttribute('data-ho-bs-deadlines') || '')
        .split(',')
        .map(function (value) { return Date.parse(value); })
        .filter(function (value) { return Number.isFinite(value); })
        .sort(function (a, b) { return a - b; });

      var values = ['days', 'hours', 'minutes'].map(function (unit) {
        return panel.querySelector('[data-ho-bs-value="' + unit + '"]');
      });

      if (!deadlines.length || values.some(function (element) { return !element; })) return;

      var state = {
        panel: panel,
        deadlines: deadlines,
        values: values,
        lastValue: null
      };

      panels.set(panel, state);
      update(state, Date.now());
    }

    function scan(root) {
      if (!root || !root.querySelectorAll) return;
      if (root.matches && root.matches(selector)) register(root);
      root.querySelectorAll(selector).forEach(register);
      tick();
    }

    function flush() {
      pendingFrame = null;
      pendingRoots.forEach(function (root) {
        if (root.isConnected) scan(root);
      });
      pendingRoots.clear();
      tick();
    }

    function queueScan(root) {
      if (root) pendingRoots.add(root);
      if (pendingFrame === null) pendingFrame = window.requestAnimationFrame(flush);
    }

    var mutationObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) queueScan(node);
        });
        record.removedNodes.forEach(function (node) {
          if (node.nodeType === 1) queueScan(null);
        });
      });
    });

    function start() {
      mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
      scan(document);
    }

    window[key] = { scan: scan };

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      panels.forEach(function (state, panel) {
        if (event.target.contains(panel)) release(panel);
      });
      syncTimer();
    });

    document.addEventListener('visibilitychange', tick);
    window.addEventListener('pageshow', function () { scan(document); });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
